// getSeedLocations - returns an array of seeded location rows
import { defaultConfigItem } from "../../constants";

// Master regions catalog (with cities) used by helpers and seed data
const masterRegions = {
  USA: [
    {
      id: "us-east",
      name: "East US",
      cities: ["New York", "Boston", "Atlanta", "Miami", "Charlotte"],
    },
    {
      id: "us-west",
      name: "West US",
      cities: [
        "San Francisco",
        "Los Angeles",
        "San Diego",
        "Seattle",
        "Portland",
      ],
    },
    {
      id: "us-central",
      name: "Central US",
      cities: ["Chicago", "Detroit", "Minneapolis", "Dallas", "Houston"],
    },
    {
      id: "us-mountain",
      name: "Mountain US",
      cities: ["Denver", "Phoenix", "Nashville", "Austin", "Tampa"],
    },
  ],
  Canada: [
    {
      id: "ca-east",
      name: "East Canada",
      cities: ["Toronto", "Montreal", "Ottawa", "Quebec City"],
    },
    {
      id: "ca-west",
      name: "West Canada",
      cities: ["Vancouver", "Calgary", "Edmonton", "Winnipeg"],
    },
  ],
};

// Helper: returns regions grouped by country, with only id and name
export function getAllRegions() {
  return {
    USA: masterRegions.USA.map(({ id, name }) => ({ id, name })),
    Canada: masterRegions.Canada.map(({ id, name }) => ({ id, name })),
  };
}

const genId = () =>
  `loc_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;

export default function getSeedLocations() {
  const types = ["Office", "Plant", "Warehouse", "Lab", "Data Center"];

  const rows = [];
  let cityIndex = 0;

  for (let i = 0; i < 25; i++) {
    const country = i % 4 === 0 ? "Canada" : "USA";
    const countryRegions = masterRegions[country];
    const regionIndex = Math.floor(i / 6) % countryRegions.length;
    const region = countryRegions[regionIndex];
    const city = region.cities[cityIndex % region.cities.length];
    const type = types[i % types.length];
    const abbr = city
      .replace(/[^a-zA-Z]/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((s) => s[0])
      .join("")
      .toUpperCase()
      .slice(0, 3);
    const isNew = i % 5 === 0;

    cityIndex++;

    const base = {
      ...defaultConfigItem,
      __id: genId(),
      // new schema fields
      locationName: `${type} - ${city}`,
      locationId: `LOC-${abbr}-${String(i + 1).padStart(2, "0")}`,
      locationUsage: i % 2 === 0 ? ["Home"] : ["Office"],
      locationType: i % 3 === 0 ? ["Business Site"] : ["Warehouse"],
      languageId: country === "Canada" ? "fr_CA" : "en_US",
      timeZoneId:
        country === "Canada"
          ? region.id === "ca-east"
            ? "EST"
            : "PST"
          : region.id === "us-east"
          ? "EST"
          : region.id === "us-west"
          ? "PST"
          : "CST",
      countryId: country,
      address: `${Math.floor(Math.random() * 900 + 100)} ${city} St, ${city}`,
      commUsage: i % 2 === 0 ? ["Shipping"] : ["Billing"],
      // reference to region only; full region metadata (name, country) is stored in the regions table
      regionId: region.id,
    };

    rows.push(isNew ? { ...base, __status: "new" } : base);
  }

  return rows;
}
